/**
 * Groups module API paths (relative to API base URL).
 */
export const GROUPS_ENDPOINTS = {
  CREATE_GROUP: '/api/v1/Groups/CreateGroup',
  UPDATE_GROUP: '/api/v1/Groups/UpdateGroup',
  JOIN_GROUP: '/api/v1/Groups/JoinGroup',
  CANCEL_JOIN_REQUEST: '/api/v1/Groups/CancelJoinRequest',
  LEAVE_GROUP: '/api/v1/Groups/LeaveGroup',
  DELETE_GROUP: '/api/v1/Groups/DeleteGroup',
  ADD_MEMBER: '/api/v1/Groups/AddMember',
  CHANGE_MEMBER_ROLE: '/api/v1/Groups/ChangeMemberRole',
  REMOVE_MEMBER: '/api/v1/Groups/RemoveMember',
  REVIEW_JOIN_REQUEST: '/api/v1/Groups/ReviewJoinRequest',
  GET_GROUPS: '/api/v1/Groups/GetGroups',
  LIST_MY_GROUPS: '/api/v1/Groups/ListMyGroups',
  GET_GROUPS_LIST: '/api/v1/Groups/GetGroupsList',
  GET_GROUP_DETAIL: '/api/v1/Groups/GetGroupDetail',
  GET_GROUP_JOIN_REQUESTS: '/api/v1/Groups/GetGroupJoinRequests',
} as const;

export default GROUPS_ENDPOINTS;
